/** How many unit-detail rows to show for a quantity (floats share a single row). */
export function unitRowCountForQuantity(quantity) {
  const qty = Math.max(0, Number(quantity) || 0);
  if (qty <= 0) return 0;
  if (Number.isInteger(qty)) return qty;
  return 1;
}

/** Allow typing intermediate float strings like "", ".", "0.", "1.25". */
export function isQuantityDraftInput(rawValue) {
  return rawValue === '' || /^\d*\.?\d*$/.test(String(rawValue));
}

/**
 * Parse a quantity string/number to a float with no rounding.
 * Empty / invalid → fallback (default 0.001). Never floors/ceils/toFixed.
 * Pass min: 0 (inventory) to allow exact zero; positive min requires n > 0.
 */
export function parseQuantityFloat(value, { min = 0.001, max = Infinity, fallback = min } = {}) {
  const n = typeof value === 'number' ? value : parseFloat(String(value ?? '').trim());
  if (!Number.isFinite(n)) return fallback;
  if (min > 0 && n <= 0) return fallback;
  if (n < 0) return fallback;
  let out = n;
  if (Number.isFinite(min) && out < min) out = min;
  if (Number.isFinite(max) && out > max) out = max;
  return out;
}
